import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { LayoutUser, SidebarProjectSummary } from "@/ui/layoutUser";
import { useWorkspaceChrome } from "@/spa/workspaceChromeContext";
import { OperatorOpsPageClient } from "./client/OperatorOpsPageClient";

export type OperatorOpsPageData = {
  pathname: string;
  user?: LayoutUser | null;
  csrfToken: string;
  sidebarProjects: SidebarProjectSummary[];
};

export const OperatorOpsPage = ({ data }: { data: OperatorOpsPageData }) => {
  const { t } = useTranslation();
  const chrome = useMemo(
    () => ({
      title: t("meta.operatorOpsTitle", { appName: t("common.appName") }),
      breadcrumbs: [{ label: t("nav.operations") }, { label: t("operatorOps.heading") }]
    }),
    [t]
  );
  useWorkspaceChrome(chrome);

  return <OperatorOpsPageClient />;
};
